import { Counter } from "./components/Counter";
import { FetchData } from "./components/FetchData";
import { Home } from "./components/Home";
import Login from "./components/Auth/Login";
import ProjectCreate from "./components/Project/Create";
import SolutionList from "./components/Solution/List";
import AssignedSolutionList from "./components/Solution/Assigned/List";
import MyProfile from "./components/Profile/MyProfile";
import CreateAccount from "./components/Auth/CreateAccount";
import UploadPhotoStep from "./components/Project/Create/Steps/UploadPhoto"
import LocationStep from "./components/Project/Create/Steps/Location";
import EstimateBudget from "./components/Project/Create/Steps/EstimateBudget";
import ProjectDetails from "./components/Project/Create/Steps/Details";
import Sprint2Step4 from "./components/Project/Create/Steps/Layout/Sprint2Step4";
import Sprint2Step5 from "./components/Project/Create/Steps/Layout/Sprint2Step5";
import Sprint2Step5Successfull from "./components/Project/Create/Steps/Layout/Sprint2Step5Successfull";
import ContractorChoose from "./components/Project/Create/Steps/EstimateBudget/Contractor/Choose";
import Success from "./components/Project/Create/Steps/Success";
import AboutBuilde from "./components/Landing/AboutBuilde";
import AddItemsStep from "./components/Project/Create/Steps/EstimateBudget/AddItems";

const AppRoutes = [
  {
    index: true,
    element: <Home/>
  },
  {
    path: '/counter',
    element: <Counter />
  },
  {
    path: '/fetch-data',
    element: <FetchData />
  },
  {
    path: '/project/create',
    element: <ProjectCreate />
  },
  {
    path: '/auth/login',
    element: <Login />
  },
  {
    path: '/solution/*',
    element: <SolutionList />
  },
  {
    path: '/my-work/*',
    element: <AssignedSolutionList />
  },
  {
    path: '/my-profile',
    element: <MyProfile />
  },
  {
    path: '/project/create/upload-photo',
    element: <UploadPhotoStep />
  },
  {
    path: '/project/create/add-items',
    element: <AddItemsStep />
  },
  {
    path: '/project/create/location',
    element: <LocationStep />
  },
  {
    path: '/project/create/estimate-budget',
    element: <EstimateBudget />
  },
  {
    path: '/project/create/details',
    element: <ProjectDetails />
  },
  {
    path: '/project/create/contractor/choose',
    element: <ContractorChoose />
  },
  {
    path: '/project/create/success',
    element: <Success />
  },
  {
    path: '/project/create/step4',
    element: <Sprint2Step4 />
  },
  {
    path: '/project/create/step5',
    element: <Sprint2Step5 />
  },
  {
    path: '/project/create/step5success',
    element: <Sprint2Step5Successfull />
  },
  {
    path: '/create-account',
    element: <CreateAccount />
  },
  {
    path: '/about',
    element: <AboutBuilde />
  }
];

export default AppRoutes;
